import axios from "./app.interceptors";

const http = {
  get: async (url, data = {}) => axios.get(url, { params: data }),
  post: async (url, data = {}, headers = {}) => axios.post(url, data, headers),
};

export default http;
